"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.011 15.916c-1.891 0-3.783.002-5.674-.002-.78 0-1.36-.357-1.693-1.056-.338-.71-.27-1.403.23-2.023.153-.191.358-.34.546-.502.46-.395.698-.893.7-1.5q.004-1.646 0-3.292c-.002-.931.164-1.83.58-2.665.907-1.817 2.35-2.952 4.36-3.288 1.851-.308 3.496.196 4.888 1.45 1.097.987 1.725 2.236 1.896 3.705.038.325.044.654.046.981q.009 1.52 0 3.04c-.004.67.245 1.215.775 1.628.329.256.62.54.774.94.451 1.17-.354 2.585-1.738 2.584zm-.01 2.582c-.545 0-1.092.005-1.637-.001-.638-.007-1.046-.595-.805-1.16.134-.315.383-.501.726-.504a245 245 0 0 1 3.439 0 .81.81 0 0 1 .794.773.82.82 0 0 1-.701.874 2 2 0 0 1-.237.018h-1.578"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertFillNavIcon20.js.map